SET_PAYMENT_ERROR